export default "__VITE_ASSET__CCoZv9nT__"